import * as vp from 'vopay';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Transactions.module.scss';

const { Button, DropDown } = vp;

type ExportType = 'pdf' | 'csv' | 'xls' | 'doc' | 'text' | 'json' | 'xml' | 'print';

type SearchFormProps = {
  onExport: (type: ExportType) => void;
};

const TransactionsExport: FunctionComponent<SearchFormProps> = ({ onExport }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Transaction.TransactionHistory.TransactionSearchForm' });
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const exportOptions: { id: string; label: string; type: ExportType }[] = [
    { id: 'export-PDF-btn', label: t('exportDd.pdf'), type: 'pdf' },
    { id: 'export-CSV-btn', label: t('exportDd.csv'), type: 'csv' },
    { id: 'export-XLS-btn', label: t('exportDd.xls'), type: 'xls' },
    { id: 'export-DOC-btn', label: t('exportDd.doc'), type: 'doc' },
    { id: 'export-Text-btn', label: t('exportDd.text'), type: 'text' },
    { id: 'export-JSON-btn', label: t('exportDd.json'), type: 'json' },
    { id: 'export-XML-btn', label: t('exportDd.xml'), type: 'xml' },
    { id: 'export-Print-btn', label: t('exportDd.print'), type: 'print' },
  ];

  return (
    <div className={styles.dropdownContainer}>
      <Button
        id="export-transactions"
        color="secondary"
        label={t('exportDd.export')}
        height="48px"
        borderRadius="10px"
        textSize={1}
        background="white"
        noShadow
        icon="arrowDown"
        iconLocation="right"
        variant="outerShadow"
        onClick={() => setIsMenuVisible(true)}
      />
      {isMenuVisible && (
        <DropDown isMenuVisible={isMenuVisible} onClick={setIsMenuVisible}>
          {exportOptions.map(({ id, label, type }) => (
            <Button
              key={id}
              id={id}
              label={label}
              background="transparent"
              textSize={1}
              width="100%"
              noShadow
              onClick={() => onExport(type)}
            />
          ))}
        </DropDown>
      )}
    </div>
  );
};

export default TransactionsExport;
